import { format } from "date-fns"
import moment from "moment"
import { CountryOptions } from "../data/CountryOptions"
import { sanitizeZipcode } from "./sanitizeZipcode"

export const normalizeParamsVendorRequest = (data) => {
    let locations = ['origin', 'destination'].map((location) => {
        return ({[location]: {
            "id": data[location]?.id || null,
            "name": data[location]?.Name || '',
            "address1": data[location]?.Name ? data[location]?.address1 : '',
            "address2": data[location]?.Name ? data[location]?.address2 : '',
            "city": data[location]?.City,
            "state": data[location]?.State,
            "zipCode": sanitizeZipcode(data[location]?.Zipcode),
            "country": data[location]?.Country?.length === 3 ? CountryOptions.filter(con => con.CodePrimus === data[location]?.Country)[0]?.Code || data[location]?.Country : data[location]?.Country,
        }})
    })
  
    return {
        shipper: locations[0].origin,
        consignee: locations[1].destination,
        insuranceAmount: data?.insuranceAmount,
        insuranceFreight: data?.insuranceFreight || false,
        insuranceAddOn: data?.insuranceAddOn || false,
        commodityInsurance: data?.commodityInsurance,
        "freightInfo": data?.freightInfo?.map((freight) => {
            return ({
                "qty": freight.qty || null,
                "weight": freight.weight || null,
                "weightType": freight.each?.toLowerCase(),
                "length": parseFloat(freight.L) || null,
                "width": parseFloat(freight.W) || null,
                "height": parseFloat(freight.H) || null,
                "dimType": freight.dimType?.value,
                "STC": freight.STC,
                "class": parseFloat(freight.class) || 0,
                "hazmat": freight.hazmat,
                "nmfc": freight.nmfc || null,
                "commodity": freight.commodity,
                "freightsnapId": freight.freightsnapId || null,
                "UN": freight?.UN,
                "stack": (freight.stack === 'No' || !freight.stack) ? false : true,
                "stackAmount": (freight.stack === 'No' || !freight.stack) ? null : parseInt(freight.stack) ? parseInt(freight.stack) : parseInt(freight.stackAmount),
            })
        }),
        "UOM": data?.freightInfoUOM?.value,
        "pickupInformation": {
            "date": data?.pickupDate?.date ? format(data?.pickupDate?.date || null, 'yyyy-MM-dd') : null,
            "type": data?.pickupDate?.type === 'PickupOn' ? "PO" : "PB",
            "timeFrom": data?.pickupDate?.from && (data?.pickupDate?.from.length > 5 ? moment(data?.pickupDate?.from, 'HH:mm:ss').format('HH:mm') : data?.pickupDate?.from.includes(':') ? data?.pickupDate?.from || "" : data?.pickupDate?.from.slice(0, 2) + ":" + data?.pickupDate?.from.slice(2)),
            "timeTo": data?.pickupDate?.to && (data?.pickupDate?.to.length > 5 ? moment(data?.pickupDate?.to, 'HH:mm:ss').format('HH:mm') : data?.pickupDate?.to.includes(':') ? data?.pickupDate?.to || "" : data?.pickupDate?.to.slice(0, 2) + ":" + data?.pickupDate?.to.slice(2)),
        },
        "deliveryInformation": {
            "date": data?.deliveryDate?.date ? format(data?.deliveryDate?.date || null, 'yyyy-MM-dd') : null,
            "type": data?.deliveryDate?.type === 'DeliveryOn' ? "DO" : "DB",
            "timeFrom": data?.deliveryDate?.from && (data?.deliveryDate?.from.length > 5 ? moment(data?.deliveryDate?.from, 'HH:mm:ss').format('HH:mm') : data?.deliveryDate?.from.includes(':') ? data?.deliveryDate?.from || "" : data?.deliveryDate?.from.slice(0, 2) + ":" + data?.deliveryDate?.from.slice(2)),
            "timeTo": data?.deliveryDate?.to && (data?.deliveryDate?.to.length > 5 ? moment(data?.deliveryDate?.to, 'HH:mm:ss').format('HH:mm') : data?.deliveryDate?.to.includes(':') ? data?.deliveryDate?.to || "" : data?.deliveryDate?.to.slice(0, 2) + ":" + data?.deliveryDate?.to.slice(2)),
        },
        "shipmentNotes": data?.instructions,
        "accessorialsList": [...data?.accessorials.origin.map((acc) => acc.code), ...data?.accessorials.destination.map((acc) => acc.code), ...data?.accessorials.other.map((acc) => acc.code)],
        "teamService": data?.teamService,
        "blanketWrap": data?.blanketWrap,
        "serviceType": data?.stops?.serviceType || '',
        "equipments": data?.stops?.equipment || [],
        "length": data?.stops?.length || 0,
        "stops": data?.stops?.stops?.length,
        "stopsDetail": data?.stops?.stops?.length ?
        data?.stops?.stops?.map(stop => {
            return ({
                "city": stop?.city?.includes(',') ? stop?.city?.split(',')[0] : (stop?.city || ''),
                "state": stop?.state || '',
                "zipCode": sanitizeZipcode(stop?.zipcode) || '',
                "country": stop?.country?.length === 2 ? CountryOptions.find(c => c.Code === stop?.country).CodePrimus : stop?.country || 'USA',
                "contact": stop?.contact || '',
                "contactPhone": stop?.contactPhone || '',
                "notes": stop?.notes || ''
            })
        }) : [],
    }
}